import { render, staticRenderFns } from "./custom-form.vue?vue&type=template&id=8c7e9654&scoped=true&"
import script from "./custom-form.vue?vue&type=script&lang=js&"
export * from "./custom-form.vue?vue&type=script&lang=js&"
import style0 from "./custom-form.vue?vue&type=style&index=0&id=8c7e9654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7e9654",
  null
  
)

export default component.exports